export const organizationRoutesViewLoaders = {
  loadOrganizationAccountView: () =>
    import(/* webpackChunkName: "organization-account-view" */ 'app/scripts/views/organization/organization-account-view.coffee').then(
      (m) => m.default,
    ),
  loadOrganizationBillingView: () =>
    import(/* webpackChunkName: "organization-billing-view" */ 'app/scripts/views/organization/organization-billing-view.coffee').then(
      (m) => m.default,
    ),
  loadOrganizationBoardsView: () =>
    import(/* webpackChunkName: "organization-boards-view" */ 'app/scripts/views/organization/organization-boards-view.coffee').then(
      (m) => m.default,
    ),
  loadOrganizationExportView: () =>
    import(/* webpackChunkName: "organization-export-view" */ 'app/scripts/views/organization/organization-export-view.coffee').then(
      (m) => m.default,
    ),
  loadOrganizationMembersView: () =>
    import(/* webpackChunkName: "organization-members-view" */ 'app/scripts/views/organization/organization-members-view.coffee').then(
      (m) => m.default,
    ),
  loadOrganizationPowerUpsView: () =>
    import(/* webpackChunkName: "organization-power-ups-view" */ 'app/scripts/views/organization/organization-power-ups-view.coffee').then(
      (m) => m.default,
    ),
};
